/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useEffect, useState } from "react";

// Argon Dashboard 2 PRO MUI components

// Argon Dashboard 2 PRO MUI example components
import { PostScheduler } from "0.Mine/0.Components/CMS/ToTranslate/PostScheduler";
import ContentCalendar from "0.Mine/0.Components/CMS/ToTranslate2_ContentCalendar/ContentCalendar";
import { UseMetricool } from "0.Mine/1.Hooks/social/metricool";
import { useBusinessContext } from "0.Mine/2.Context/businessContext";
import ArgonBox from "components/ArgonBox";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import BusinessNavbar from "examples/Navbars/DashboardNavbar/businessNavbar";

const CMSSocial = () => {
  return (
    <DashboardLayout>
      <CMSSocialWithContext />
    </DashboardLayout>
  );
};

function CMSSocialWithContext() {
  const [posts, setPosts] = useState([]);
  const { session } = useBusinessContext();
  const { getallMetricsAndPosts } = UseMetricool();

  const addPostToCalendar = (post) => {
    console.log("Adding post to calendar:", post);
    setPosts((prevPosts) => {
      const updatedPosts = [...prevPosts, post];
      console.log("Updated posts:", updatedPosts);
      return updatedPosts;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (session && session.selectedBusiness && session.selectedBusiness.id) {
          const response = await getallMetricsAndPosts(session.selectedBusiness.id);
          if (!response) return;
          setPosts(response);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchData();
  }, [session]);

  return (
    <>
      <BusinessNavbar />
      <ArgonBox py={3} pb="70px">
        {" "}
        {/* Added bottom padding for footer */}
        <ArgonBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <ArgonBox sx={{ position: "relative", zIndex: 20 }}>
                <PostScheduler addPostToCalendar={addPostToCalendar} />
              </ArgonBox>
            </Grid>
          </Grid>
        </ArgonBox>
        <ArgonBox mb={3}>
          <ContentCalendar posts={posts} />
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </>
  );
}

export default CMSSocial;
